<ng-container [formGroup]="form">
    @if (question.paragraph) {
        <span class="me-2"> {{ question.paragraph | translate }}</span>
    }
    <mat-form-field
        class="ca-form-field"
        [floatLabel]="question.floatingLabel"
        [hideRequiredMarker]="true"
        subscriptSizing="dynamic"
        appearance="outline"
        [ngClass]="question | formFieldStyles"
    >
        @if (question.label) {
            <mat-label [attr.for]="question.key">{{ question.label | translate }}</mat-label>
        }
        <input
            [formControlName]="question.key"
            [placeholder]="question.placeholder | translate"
            [id]="question.key"
            [attr.data-testid]="question.key"
            [type]="question.type"
            [mask]="question.mask.pattern"
            [patterns]="$any(question).mask?.customPatterns"
            (input)="onInput($event)"
            (blur)="onBlur()"
            [decimalMarker]="$any(question).mask?.decimalMarker"
            [separatorLimit]="$any(question).mask?.separatorLimit"
            [dropSpecialCharacters]="
                ($any(question).mask?.dropSpecialCharacters | isNil) ? true : $any(question).mask?.dropSpecialCharacters
            "
            [suffix]="question.suffix ? ' ' + (question.suffix | translate) : ''"
            matInput
        />
        @if (hint) {
            <mat-hint> {{ hint | translate }}</mat-hint>
        }
        @if (question.permanentHint) {
            <mat-hint> {{ question.permanentHint | translate }}</mat-hint>
        }
        @if (question.ifConditionalHint && question.conditionalHint) {
            <mat-hint> {{ question.conditionalHint | translate }}</mat-hint>
        }
        @if (isInvalid && errorMessage) {
            <mat-error>
                <ca-form-error-message [attr.data-testid]="question.key + '-error-message'">
                    {{ errorMessage | translate }}
                </ca-form-error-message>
            </mat-error>
        }
    </mat-form-field>
    @if (question.paragraph) {
        <span class="ms-1">.</span>
    }
</ng-container>
